import { useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Plus, Check, X } from "lucide-react";

export default function CategorySelect({ value, onChange, categories, onAdded, testid = "exp-category" }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");

  const save = async () => {
    if (!name.trim()) return;
    try {
      const { data } = await api.post("/expense-categories", { name: name.trim() });
      toast.success("Kategori eklendi");
      onAdded?.(); onChange(data.name); setAdding(false); setName("");
    } catch (e) { toast.error(e?.response?.data?.detail || "Eklenemedi"); }
  };

  if (adding) return (
    <div className="flex gap-2">
      <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="Yeni kategori adı" data-testid={`${testid}-new-input`} />
      <Button type="button" size="icon" className="bg-[#1B4D3E] hover:bg-[#163e32] shrink-0" onClick={save} data-testid={`${testid}-new-save`}><Check size={16} /></Button>
      <Button type="button" size="icon" variant="outline" className="shrink-0" onClick={() => setAdding(false)}><X size={16} /></Button>
    </div>
  );

  return (
    <div className="flex gap-2">
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Kategori seç" /></SelectTrigger>
        <SelectContent>{categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
      </Select>
      <Button type="button" variant="outline" size="icon" className="shrink-0" title="Yeni kategori" onClick={() => setAdding(true)} data-testid={`${testid}-add-btn`}><Plus size={16} /></Button>
    </div>
  );
}
